import React, { useState, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

export default function ReceiptLayoutSettings() {
  const [header, setHeader] = useState("");
  const [footer, setFooter] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const schoolName = "Demo School For Development";

  // 1. Fetch initial data on component mount
  useEffect(() => {
    getReceiptSettings();
  }, []);

  const getReceiptSettings = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    // Use the specific fetch body structure
    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      language: "en",
    };

    try {
      // Calling the specific endpoint for receipt layout
      const response = await simplePostCall(ApiConfig.receiptlayout, JSON.stringify(requestBody));

      if (response?.result && response?.invoice_layout?.length > 0) {
        // Adjust these mapping keys based on your specific GET response keys
        const data = response.invoice_layout[0];
        setHeader(data.invoice_header || ""); 
        setFooter(data.invoice_footer || "");
      }
    } catch (error) {
      console.error("Error fetching receipt settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // 2. Save data with the new Payload structure
  const handleSave = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const user_id = localStorage.getItem("user_id");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      user_id: Number(user_id),
      language: "en",
      ReceiptLayout: [
        {
          receipt_layout_header: header,
          receipt_layout_footer: footer,
        },
      ],
    };

    try {
      const response = await simplePostCall(ApiConfig.receiptlayout, JSON.stringify(requestBody));

      if (response?.result) {
        toast.success("Receipt Layout Saved Successfully!", {
          autoClose: 1500,
        });
      } else {
         toast.warning(response?.message || "Failed to save layout.");
      }
    } catch (error) {
      console.error("Error saving receipt layout:", error);
      toast.error("An error occurred while saving.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="receiplayout-container my-4">
    <ToastContainer/>
      <div className="col-md-12">
        <div className="special-header panel-white-all mb-4">
          <h4 className="page-title mt-1">Receipt Layout Settings</h4>
        </div>
        
        <div className="receip-bg p-4 border rounded bg-white">
          <div className="editor-section mb-4">
            <label className="fw-bold mb-2">Enter Receipt Header</label>
            <CKEditor
              editor={ClassicEditor}
              data={header}
              onChange={(event, editor) => setHeader(editor.getData())}
            />
          </div>

          <div className="editor-section mb-4">
            <label className="fw-bold mb-2">Enter Receipt Footer</label>
            <CKEditor
              editor={ClassicEditor}
              data={footer}
              onChange={(event, editor) => setFooter(editor.getData())}
            />
          </div>

          <div className="d-flex justify-content-end mb-5">
            <button 
              className="btn custom-btn px-3" 
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>

          {/* Live Receipt Preview */}
          <div className="receipt-preview-container">
            <h5 className="text-center text-muted mb-3">--- Preview ---</h5>
            <div className="receipt-preview p-4 border shadow-sm" style={{ backgroundColor: "#fff" }}>
              
              {/* Dynamic Header */}
              <div 
                dangerouslySetInnerHTML={{ __html: header }} 
                className="mb-4 text-center"
              />

              <div style={{ fontWeight: "700", fontSize: "24px", textAlign: "center", marginBottom: "20px", backgroundColor: "#f2f5f6", padding: "10px", borderRadius: "6px" }}>
                {schoolName}
              </div>

              <p><strong>Hi Parents,</strong></p>
              <h4 className="text-center mb-4">Monthly Subscription Receipt</h4>

              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Sl.No.</th>
                    <th>Description</th>
                    <th>Type</th>
                    <th>Amount ($)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Fee Payment</td>
                    <td>Web</td>
                    <td>40</td>
                  </tr>
                  <tr className="fw-bold">
                    <td colSpan={3} className="text-end">Total Amount</td>
                    <td>40</td>
                  </tr>
                </tbody>
              </table>

              {/* Dynamic Footer */}
              <div 
                dangerouslySetInnerHTML={{ __html: footer }} 
                className="mt-4 text-center"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}